import { render } from "./CTAButton.vue?vue&type=template&id=919436ae"
import script from "./CTAButton.vue?vue&type=script&lang=js"
export * from "./CTAButton.vue?vue&type=script&lang=js"

import "./CTAButton.vue?vue&type=style&index=0&id=919436ae&lang=sass"

import exportComponent from "/Users/jiun/Documents/case/2021/BMW/testing/filter/bmw_teaser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__